import { useSignupModal } from "@/features/signup/SignupModal";
import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import { ButtonLink } from "@/shared/components/ButtonLink/ButtonLink";
import styles from "./AiFirst.module.css";

function accentuate(text: string, accent: string) {
  const index = text.indexOf(accent);
  if (index < 0) return text;
  return (
    <>
      {text.slice(0, index)}
      <span className={styles.accent}>{accent}</span>
      {text.slice(index + accent.length)}
    </>
  );
}

export function AiFirst() {
  const { aiFirst } = useMaestriaContent();
  const openSignup = useSignupModal();

  return (
    <section
      id="ai-first"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="ai-first-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <div className={styles.header}>
          <h2 id="ai-first-title" className={styles.title}>
            {accentuate(aiFirst.title, "AI-First")}
          </h2>
          <p className={styles.subtitle}>{aiFirst.subtitle}</p>
        </div>

        <div className={styles.divider} aria-hidden="true" />

        <ul className={styles.pillars}>
          {aiFirst.pillars.map((pillar) => (
            <li key={pillar.title} className={styles.pillar}>
              <img src={pillar.icon} alt="" width={120} height={120} loading="lazy" />
              <div className={styles.pillarCopy}>
                <h3>{pillar.title}</h3>
                <p className={styles.chip}>{pillar.description}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className={styles.divider} aria-hidden="true" />

        <p className={styles.note}>
          {aiFirst.note}
          <strong>{aiFirst.noteAccent}</strong>
        </p>
        <div className={styles.cta}>
          <ButtonLink onClick={openSignup} className={styles.ctaButton}>
            {aiFirst.cta.label}
          </ButtonLink>
        </div>
      </div>
    </section>
  );
}
